module.exports = __webpack_public_path__ + "static/media/events.9566c8ed.png";